export const environment = {
  production: false,
  api: 'https://site.homolog.febrasgo.org.br/app/int/',
  auth: 'https://sistema.homolog.febrasgo.org.br/api/login/associado',
  sysApi: 'https://sistema.homolog.febrasgo.org.br/api',
  site: 'https://site.homolog.febrasgo.org.br'
};
